import { Fragment } from "react";
import "./CryptoWallet.css";
import { cryptowalletDevelopment } from "../../staticdata";
import cryptowalletbanner from "../../assets/images/services/crypto/cryptowalletbanner.png";


const CryptoWallet = () => {
  return (
    <Fragment>
      <section className="cryptowallet-style">
        <div className="cryptowallet-banner">
          <div className="row">
            <div className="col-lg-6">
              <div className="cryptowallet-desc">
                <h1
                  className="text-start"
                  data-aos="fade-up-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Crypto Wallet Development Services
                </h1>
                <p
                  className="text-start"
                  data-aos="fade-up-left"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Experience the future of digital currency management with
                  Kairaa cutting-edge platform. Our crypto wallet development
                  services guarantee world-class security and stability for your
                  highly scalable payment integration solutions. As a top
                  cryptocurrency wallet development company, we specialize in
                  crafting ultra-secure cryptocurrency wallets, empowering you
                  to earn, transfer, and monitor virtual currencies with
                  confidence.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="image-blend-wrapper"
                data-aos="fade-left"
                data-aos-offset="300"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={cryptowalletbanner}
                  alt="image not found"
                  loading="lazy"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
        <div className="cryptowallet-services">
          <div className="container">
            <div
              className="section-title mt-5 mb-5"
              data-aos="fade-down"
              data-aos-duration="800"
            >
              <h2 className="text-center">
                Our{" "}
                <span className="title-gradient">Crypto Wallet Development </span>{" "}
                Service
              </h2>
            </div>
            <div className="row gy-4 d-flex justify-content-center">
              {cryptowalletDevelopment.map((services, index) => (
                <div
                  className="col-lg-4 col-md-6"
                  key={services.id}
                  data-aos="zoom-in"
                >
                  <div className="cryptowallet-card">
                    <div className="icon-wrap">
                      <img
                        src={services.icon}
                        alt="img not found"
                        style={{ width: "62px", height: "62px" }}
                      />
                    </div>
                    <h5>{services.title}</h5>
                    <p className="text-light mb-0">{services.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default CryptoWallet;
